import { IClient } from "..";
import {
  IconFacebook,
  IconInstagram,
  IconLinkedin,
  IconTiktok,
  IconX,
  IconYoutube,
  LogoGenial,
  LogoGenialColor,
} from "../../assets";

export const Genial: IClient = {
  colors: {
    primary: [
      "#172056", //0
      "#364DCD", //1
      "#364DCD", //2
      "#364DCD", //3
      "#364DCD", //4
    ],
    primaryOpacity: [
      "#EAF0FC", //0
      "#EBEEFA", //1
      "#EBEEFA", //2
      "#EBEEFA", //3
      "#EBEEFA", //4
    ],
    complementary: [
      "#169C3C", //0
      "#2C1B73", //1
      "#E3183B", //2
      "#8131E6", //3
      "#FB6815", //4
      "#EB49EE", //5
      "#319CE6", //6
      "#5E71D7", //7
    ],
    complementaryOpacity: [
      "#E8F5EC", //0
      "#EAE8F1", //1
      "#FCE8EB", //2
      "#F2EAFC", //3
      "#FFEEDE", //4
      "#FDEDFD", //5
      "#EAF5FC", //6
      "#EAF0FC", //7
    ],
    basic: [
      "#FFFFFF", //0
      "#F0F0F0", //1
      "#D7D7D7", //2
      "#B2B1B1", //3
      "#6B6B6B", //4
      "#2F2F2F", //5
    ],
    other: [
      "#FAFBFE", //0
      "#B9B9B9", //1
      "#191C33", //2
      "#050922", //3
      "#DEDEDE", //4
      "#B3B1B1", //5
    ],
    alerts: [
      "#F43333", //0
      "#FAAB36", //1
      "#23BD32", //2
      "#EB4747", //3
    ],
    alertsOpacity: [
      "#FEEBEB", //0
      "#FEF7EB", //1
      "#E9F8EB", //2
    ],
  },
  image: {
    logo: LogoGenial,
    icon: LogoGenial,
    logo2: LogoGenialColor,
    icon2: LogoGenialColor,
  },
  name: "Genial",
  title: "Genial Investimentos",
  favicon: "favicon-genial.ico",
  description: "Genial - Predix e Copytrading.",
  acceptLanguage: ["pt-BR", "en-US", "es"],
  autoRegister: false,
  hasBrokers: false,
  hasCancelButton: true,
  hasClarity: false,
  redirect: "/marketplace/predix",
  hasFinancial: false,
  email: {
    email: "global.footer.email",
    link: "https://genialhelp.zendesk.com/hc/pt-br",
  },
  terms: {
    pt_br: "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
    en_us: "https://spidertrader.com.br/en/terms-of-use/",
    es: "https://spidertrader.com.br/es/condiciones-de-uso/",
  },
  privacyPolicy: {
    pt_br:
      "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
    en_us: "https://spidertrader.com.br/en/privacy-policy/",
    es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
  },
  contacts: [
    {
      name: "global.footer.callcenter",
      contact: "tel: +551140048888",
      contactText: "4004-8888",
    },
    {
      name: "global.footer.ombudsman",
      contact: "tel: +5508006888888",
      contactText: "0800-688-8888",
      description: "global.footer.ombudsman_description",
    },
  ],
  footerLinksTerms: [
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/politica-de-privacidade-de-dados-pessoais",
        en_us: "https://spidertrader.com.br/en/privacy-policy/",
        es: "https://spidertrader.com.br/es/politica-de-privacidad-de-datos-personales/",
      },
      name: "global.routes_names.privacy_policy",
    },
    {
      path: {
        pt_br:
          "https://spidertrader.com.br/termo-de-uso-do-site-e-aplicativos/",
        en_us: "https://spidertrader.com.br/en/terms-of-use/",
        es: "https://spidertrader.com.br/es/condiciones-de-uso/",
      },
      name: "global.routes_names.terms_of_use",
    },
    {
      path: {
        pt_br: "https://genialhelp.zendesk.com/hc/pt-br",
        en_us: "https://genialhelp.zendesk.com/hc/en",
        es: "https://genialhelp.zendesk.com/hc/es",
      },
      name: "global.routes_names.help_center",
    },
  ],
  navbarLinksDefault: [
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      subLinks: [
        // { name: "global.routes_names.copytrading", path: "/marketplace" },
        // { name: "global.routes_names.daytrade", path: "/marketplace/daytrade" },
        // {
        //   name: "global.routes_names.swingtrade",
        //   path: "/marketplace/swingtrade",
        // },
        // { name: "global.routes_names.wallets", path: "/marketplace/wallets" },
        {
          name: "global.routes_names.predictives",
          path: "/marketplace/predix",
        },
      ],
    },
  ],
  navbarLinksClient: [
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      subLinks: [
        // { name: "global.routes_names.copytrading", path: "/marketplace" },
        // { name: "global.routes_names.daytrade", path: "/marketplace/daytrade" },
        // {
        //   name: "global.routes_names.swingtrade",
        //   path: "/marketplace/swingtrade",
        // },
        // { name: "global.routes_names.wallets", path: "/marketplace/wallets" },
        {
          name: "global.routes_names.predictives",
          path: "/marketplace/predix",
        },
      ],
    },
    // {
    //   name: "global.routes_names.my_portfolio",
    //   path: "/meu-portfolio",
    //   subLinks: [
    //     {
    //       name: "global.routes_names.my_portfolio_purchases",
    //       path: "/meu-portfolio/minhas-compras",
    //     },
    //   ],
    // },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        // {
        //   name: "global.routes_names.operations_performance",
        //   path: "/operacoes/desempenho",
        // },
        // {
        //   name: "global.routes_names.operations_positions",
        //   path: "/operacoes/posicoes",
        // },
        // {
        //   name: "global.routes_names.operations_orders",
        //   path: "/operacoes/ordens",
        // },
        {
          name: "global.routes_names.predictives",
          path: "/operacoes/predix",
        },
      ],
    },
  ],
  navbarLinksAnalyst: [
    {
      name: "global.routes_names.marketplace",
      path: "/marketplace",
      subLinks: [
        // { name: "global.routes_names.copytrading", path: "/marketplace" },
        // { name: "global.routes_names.daytrade", path: "/marketplace/daytrade" },
        // {
        //   name: "global.routes_names.swingtrade",
        //   path: "/marketplace/swingtrade",
        // },
        // { name: "global.routes_names.wallets", path: "/marketplace/wallets" },
        {
          name: "global.routes_names.predictives",
          path: "/marketplace/predix",
        },
      ],
    },
    // {
    //   name: "global.routes_names.my_portfolio",
    //   path: "/meu-portfolio",
    //   subLinks: [
    //     {
    //       name: "global.routes_names.my_portfolio_products",
    //       path: "/meu-portfolio/meus-servicos",
    //     },
    //   ],
    // },
    {
      name: "global.routes_names.operations",
      path: "/operacoes",
      subLinks: [
        // {
        //   name: "global.routes_names.operations_performance",
        //   path: "/operacoes/desempenho",
        // },
        // {
        //   name: "global.routes_names.operations_positions",
        //   path: "/operacoes/posicoes",
        // },
        // {
        //   name: "global.routes_names.operations_orders",
        //   path: "/operacoes/ordens",
        // },
        {
          name: "global.routes_names.predictives",
          path: "/operacoes/predix",
        },
      ],
    },
  ],
  socialLinks: [
    {
      path: "https://www.instagram.com/genialinvestimentos/",
      icon: IconInstagram,
      name: "Instagram",
    },
    {
      path: "https://www.youtube.com/genialinvestimentos",
      icon: IconYoutube,
      name: "Youtube",
    },
    {
      path: "https://www.linkedin.com/company/genialinvestimentos/",
      icon: IconLinkedin,
      name: "Linkedin",
    },
    {
      path: "ttps://www.facebook.com/genialinvestimentos",
      icon: IconFacebook,
      name: "Facebook",
    },
    {
      path: "https://x.com/genialinveste",
      icon: IconX,
      name: "X",
    },
    {
      path: "https://www.tiktok.com/@genialinveste",
      icon: IconTiktok,
      name: "TikTok",
    },
  ],
};
